import { render, staticRenderFns } from "./aboutPn.vue?vue&type=template&id=36ad66fe&scoped=true&"
import script from "./aboutPn.vue?vue&type=script&lang=js&"
export * from "./aboutPn.vue?vue&type=script&lang=js&"
import style0 from "./aboutPn.vue?vue&type=style&index=0&id=36ad66fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ad66fe",
  null
  
)

export default component.exports